// extracted by mini-css-extract-plugin
module.exports = {"message":"style_message__1ij07","icon":"style_icon__pxaFC","title":"style_title__2F2XX","description":"style_description__290Ns"};